import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  rowWrap: FelaCSS;
  tagWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    marginBottom: '5px',
  },

  rowWrap: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    // LIVE-14086: used to display max 2 rows of tags in supplier-info-card
    maxHeight: '44px',
    overflow: 'hidden',
  },

  tagWrap: {
    marginBottom: '5px',
    marginRight: '5px',

    ':not(:last-of-type)': {
      marginRight: '8px',
    },
  },
});

export default styles;
